import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { AboutPage } from './pages/about/about.page';
import { HomePage } from './pages/home/home.page';

import {IvyCarouselModule} from 'angular-responsive-carousel';
import { ContactProvider } from './providers/contact.provider';
import { DataProvider } from './providers/data.provider';
import { SeoProvider } from './providers/seo.provider';
import { Settings } from './app.settings';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { SEOService } from './services/seo.service';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';

@NgModule({
  declarations: [
    AppComponent,
    HomePage,
    AboutPage,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    IvyCarouselModule,
    FormsModule,
    HttpClientModule,
    RecaptchaFormsModule,
    RecaptchaModule
  ],
  providers: [
    DataProvider,
    SeoProvider,
    ContactProvider,
    Settings,
    SEOService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
